import type { PayloadAction } from '@reduxjs/toolkit'
import { patchRequest, requests } from 'redux/redux-modules'
import { getRequestsParams } from 'redux/redux-modules/v4/get-requests/get-requests.module.utils'
import { put, select } from 'redux-saga/effects'

import { clearSelectedRequest } from '../actions'
import { orderBySelector, selectedStatusOptionSelector } from '../selectors'

export function* closeSelectedActionSaga(action: PayloadAction<boolean>) {
  const shouldReloadRequests = action.payload

  yield put(clearSelectedRequest())

  if (shouldReloadRequests) {
    const selectedOptionStatus = yield select(selectedStatusOptionSelector)
    const orderBy = yield select(orderBySelector)

    yield put(patchRequest.actions.setError(null))
    yield put(patchRequest.actions.setData(null))
    yield put(
      requests.actions.makeRequest({ params: getRequestsParams(selectedOptionStatus, orderBy) }),
    )
  }
}
